export default "__VITE_ASSET__BPxy2vNO__"